/**
 * Generic image asset interface that both ImageGenerationWidgetImage
 * and FileAssetWithUrl satisfy
 */
export interface ImageAsset {
  assetId: string;
  metadata: {
    fileName: string;
  };
}

export enum InfoMenuType {
  Text = 'Text',
  Date = 'Date',
  LongText = 'LongText',
  Image = 'Image',
}

export interface InfoMenuComponentProps<T extends ImageAsset = ImageAsset> {
  value: InfoMenuValue<T>;
}

type InfoMenuValue<T extends ImageAsset = ImageAsset> = string | T[];

export interface InfoMenuEntry<T extends ImageAsset = ImageAsset> {
  type: InfoMenuType;
  value: InfoMenuValue<T>;
}

export type InfoMenuInput<T extends ImageAsset = ImageAsset> = Array<
  Record<string, InfoMenuEntry<T>>
>;

export interface InfoMenuProps<T extends ImageAsset = ImageAsset> {
  /** Menu input data */
  input: InfoMenuInput<T> | null;
  /** Anchor element for the menu */
  anchorEl: HTMLElement | null;
  /** Whether the menu is open */
  open: boolean;
  /** Callback when menu should close */
  onClose: () => void;
}
